import { render, staticRenderFns } from "./TheConsultorio.vue?vue&type=template&id=4ce9bd20&scoped=true&"
import script from "./TheConsultorio.vue?vue&type=script&lang=js&"
export * from "./TheConsultorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce9bd20",
  null
  
)

export default component.exports